import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { BRAND, SEGMENTS, telLink, waLink } from "../lib/data";

const LINKS = [
  { label: "Genesis Group", to: "/about" },
  { label: "Genesis Mall", to: "/mall" },
  { label: "Our Businesses", to: "/businesses" },
  { label: "Rural Connect", to: "/rural-connect" },
  { label: "Affiliate & Opportunity", to: "/opportunity" },
  { label: "Ranks & Rewards", to: "/ranks-rewards" },
  { label: "Contact", to: "/contact" },
];

export const Footer = () => {
  return (
    <footer className="bg-forest-800 text-cream-100 pt-0 pb-24 sm:pb-10" data-testid="site-footer">
      <div className="weave-divider" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Logo />
            <p className="text-cream-200/80 text-sm mt-4 leading-relaxed">
              <span className="text-saffron-500 font-semibold">{BRAND.mall}</span> — {BRAND.businessCenter}. A growing ecosystem connecting businesses, services, shopping, opportunities and local enterprise across Bharat.
            </p>
            <p className="text-cream-200 text-sm mt-3 italic">{BRAND.bharatTagline}</p>
            <div className="flex gap-3 mt-5">
              <a href={waLink()} target="_blank" rel="noreferrer nofollow" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center text-cream-50 hover:bg-white/20 transition-colors" data-testid="footer-whatsapp"><MessageCircle className="w-4 h-4" /></a>
              <a href={telLink} className="w-9 h-9 rounded-lg bg-saffron-500/20 flex items-center justify-center text-saffron-500 hover:bg-saffron-500/30 transition-colors" data-testid="footer-call"><Phone className="w-4 h-4" /></a>
              <a href={`mailto:${BRAND.email}`} className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center text-cream-50 hover:bg-white/20 transition-colors" data-testid="footer-email"><Mail className="w-4 h-4" /></a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-cream-50 mb-4">Ecosystem</h4>
            <ul className="space-y-2.5">
              {LINKS.map((l) => (
                <li key={l.to}><Link to={l.to} className="text-cream-200/80 hover:text-saffron-500 text-sm transition-colors">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-cream-50 mb-4">Businesses</h4>
            <ul className="space-y-2.5">
              {SEGMENTS.slice(0, 7).map((s) => (
                <li key={s.slug}><Link to={`/businesses/${s.slug}`} className="text-cream-200/80 hover:text-saffron-500 text-sm transition-colors">{s.short}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-cream-50 mb-4">Get in Touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3 text-cream-200/80"><Phone className="w-4 h-4 text-saffron-500 mt-0.5 shrink-0" /><a href={telLink} className="hover:text-cream-50">{BRAND.phoneDisplay}</a></li>
              <li className="flex items-start gap-3 text-cream-200/80"><Mail className="w-4 h-4 text-saffron-500 mt-0.5 shrink-0" /><a href={`mailto:${BRAND.email}`} className="hover:text-cream-50 break-all">{BRAND.email}</a></li>
              <li className="flex items-start gap-3 text-cream-200/80"><MapPin className="w-4 h-4 text-saffron-500 mt-0.5 shrink-0" /><span>{BRAND.states.join(" · ")}</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-cream-200/70 text-xs text-center sm:text-left">© {new Date().getFullYear()} {BRAND.full} — {BRAND.legal}. All rights reserved.</p>
          <div className="flex items-center gap-4 text-xs text-cream-200/70">
            <Link to="/contact" className="hover:text-saffron-500" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/contact" className="hover:text-saffron-500" data-testid="footer-terms">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
